module.exports = __webpack_public_path__ + "static/media/d17ru.b0f1c7af.pdf";